import React from 'react';

export default function LoadingSpinner() {
  return (
    <div className="cargando-full-screen2">
      <div className="claro-spinner" />
    </div>
  );
}
